//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import mixins from '../mixins/index'
  import SchoolRanking from './common/schoolRanking'
export default {
  name: 'dnaerGirls',
  mixins: [mixins],
  components: {
    SchoolRanking
  },
  data () {
    return {
      downloadUrl: '',
      isShowMask: false,
      schoolInfo: {},
      rankingList: [],
      token: '',
      GetMobelType: {}
    }
  },
  mounted () {
    this.handleGetMobelType()
    this.handleGetNewVersion()
    switch (this.$route.path) {
      case '/superDNAer/':
        this.schoolInfo = {
          schoolAbbreviation: '河南大学',
          schoolName: '河南大学',
          isShowRanking: true,
          schoolCode: '18051'
        };
        this.handleGetRanking()
        break;
      case '/superDNAer/zzu/':
        this.schoolInfo = {
          schoolAbbreviation: '郑州大学',
          schoolName: '郑州大学',
          isShowRanking: true,
          schoolCode: '18001'
        };
        this.handleGetRanking()
        break;
      case '/superDNAer/huel/':
        this.schoolInfo = {
          schoolAbbreviation: '河南财大',
          schoolName: '河南财经政法大学',
          isShowRanking: true,
          schoolCode: ' 18010'
        };
        this.handleGetRanking()
        break;
      case '/superDNAer/lynu/':
        this.schoolInfo = {
          schoolAbbreviation: '洛阳师院',
          schoolName: '洛阳师范学院',
          isShowRanking: false,
          schoolCode: ''
        };
        break;
      case '/superDNAer/kfu/':
        this.schoolInfo = {
          schoolAbbreviation: '开封大学',
          schoolName: '开封大学',
          isShowRanking: false,
          schoolCode: ''
        };
        break;
      default:
        this.schoolInfo = {
          schoolAbbreviation: '各所高校',
          schoolName: '各所高校',
          isShowRanking: false,
          schoolCode: ''
        };
    }
  },
  methods: {
    handleChangeMaskShow () {
      this.isShowMask = !this.isShowMask
    },
    handleGetRanking () {
      this.axios('/user/user/mobile/v1/integral/ranking', {
        schoolCode: this.schoolInfo.schoolCode,
        schoolName: this.schoolInfo.schoolName,
        token: this.token,
        pageIndex: 1,
        pageSize: 9
      }).then((res) => {
        let list = res.data.data
        for (let item of list){
          if (item.realName) {
            item.realName = '*' +  item.realName.slice(1)
          }
        }
       this.rankingList = res.data.data
      })
    },
    handleGetMobelType () {
      let browser = { }
      let u = window.navigator.userAgent
      browser = {
        trident: u.indexOf('Trident') > -1,
        presto: u.indexOf('Presto') > -1,
        Alipay: u.indexOf('Alipay') > -1,
        webKit: u.indexOf('AppleWebKit') > -1,
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1,
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1,
        iPad: u.indexOf('iPad') > -1,
        webApp: u.indexOf('Safari') === -1,
        weixin: u.indexOf('MicroMessenger') > -1,
        qq: u.match(/\sQQ/i) !== null,
        Safari: u.indexOf('Safari') > -1
      }
      this.GetMobelType = browser
      this.type = this.GetMobelType.android


    },
    handlePhoneJump () {
      let _this = this
      if (this.GetMobelType.weixin) {
        this.isShowMask = true
      } else {
        if (this.GetMobelType.android) {
          window.location.href = _this.downloadUrl
        }
        if (this.GetMobelType.ios || this.GetMobelType.iPhone || this.GetMobelType.iPad) {
          if (this.GetMobelType.qq) {
            this.isShowMask = true
          } else {
            window.location.href = 'https://apps.apple.com/cn/app/dnaer叮了-实名社交系统/id1479806321?l=zh&ls=1'
          }
        }
      }
    },
    handleGetNewVersion () {
      this.axios('/plugin/unCheck/app/version/mobile/v1/lastOne',{platform: 'android'}).then((res) => {
        this.downloadUrl = res.data.data.url
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/superDnaer.vue